module.exports = __webpack_public_path__ + "img/b1b2961211e56812e3c0e9c380761cd6.png";